import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js';
import moduleECommerce from './eCommerce/moduleECommerce.js';
import firebaseAuth from './firebase/firebaseAuth';
import firebaseRealtime from './firebase/firebaseRealtimeDB';
import firebaseStorage from './firebase/firebaseStorage';

// import resource from '@/components/design-form/store/index.js';
import resource from '@/serviforms/designer/store/index.js';
import usuario from '@/serviforms/users/store/index.js';


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    // todo: moduleTodo,
    // calendar: moduleCalendar,
    // chat: moduleChat,
    // email: moduleEmail,
    auth: moduleAuth,
    eCommerce: moduleECommerce,
    firebaseAuth,
    firebaseRealtime,
    firebaseStorage,
    resource,
    usuario
  },
  // strict: process.env.NODE_ENV !== 'production'
});
